import { useSupabaseQuery, useSupabaseRow } from './useSupabaseQuery';
import type { User } from '../types/database';

export function useUsers(filters?: { search?: string; limit?: number; offset?: number }) {
	const limit = filters?.limit ?? 50;
	const offset = filters?.offset ?? 0;
	return useSupabaseQuery<User>(
		(client) => {
			let q = client
				.from('users')
				.select('*', { count: 'exact' })
				.order('created_at', { ascending: false })
				.range(offset, offset + limit - 1);
			if (filters?.search) {
				q = q.or(
					`phone_number.ilike.%${filters.search}%,display_name.ilike.%${filters.search}%`
				);
			}
			return q;
		},
		[filters?.search, limit, offset]
	);
}

export function useUser(id: string | undefined) {
	return useSupabaseRow<User>('users', id);
}
